import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //主页
    {
      path: '/',
      name: 'index',
      component: () => import("./views/card/xinXunIndex.vue"),
      meta: {
        title: '设备管理',
      }
    },
    {
      path: '/card',
      component: () => import("./views/card/cardLayout.vue"),
      children: [
        {
          path: 'binding',
          name: 'binding',
          component: () => import("./views/card/binding.vue"),
        }, {
          path: 'xinXunIndex',
          name: 'xinXunIndex',
          component: () => import("./views/card/xinXunIndex.vue"),

        }
        // , {
        //   path: 'xinXunIndexCS',
        //   name: 'xinXunIndexCS',
        //   component: () => import("./views/card/xinXunIndexCS.vue"), // 客服链接
        //   meta: {
        //     login: false
        //   }
        // }
        , {
          path: 'plan_list',
          name: 'plan_list',
          component: () => import("./views/card/plan_list.vue"),
          meta: {
            title: '套餐充值',
          }
        }, {
          path: 'package_details',
          name: 'package_details',
          component: () => import("./views/card/packageDetails.vue"),
          meta: {
            title: '套餐详情',
          }
        }, {
          path: 'recharge',
          name: 'recharge',
          component: () => import("./views/card/recharge.vue"),
          meta: {
            title: '充值'
          }
        }, {
          path: 'more_flow_plan',
          component: () => import("./views/card/more_flow_plan.vue"),
          meta: {
            title: '加油包叠加对应套餐'
          }
        }
        , {
          path: 'usage',
          name: 'usage',
          component: () => import("./views/card/usage.vue"),
          meta: {
            title: '卡信息',
          }
        }, 
        // {
        //   path: 'networkOptimization',
        //   name: 'networkOptimization',
        //   component: () => import("./views/card/networkOptimization.vue"),
        //   meta: {
        //     title: '切换网络',
        //   }
        // }, {
        //   path: 'remoteControl',
        //   name: 'remoteControl',
        //   component: () => import("./views/card/remoteControl.vue"),
        //   meta: {
        //     title: '远程控制',
        //   }
        // }, {
        //   path: 'coupon',
        //   name: 'coupon',
        //   component: () => import("./views/card/coupon.vue"),
        //   meta: {
        //     title: '卡券兑换',
        //   }
        // }, {
        //   path: 'card_invoice',
        //   name: 'card_invoice',
        //   component: () => import("./views/card/card_invoice.vue"),
        //   meta: {
        //     title: '开具发票'
        //   }
        // }, {
        //   path: 'xinXunIndex_TB',
        //   name: 'xinXunIndex_TB',
        //   component: () => import("./views/card/xinXunIndex_TB.vue"), // 淘工厂

        // }, {
        //   path: 'recharge_TB',
        //   name: 'recharge_TB',
        //   component: () => import("./views/card/recharge_TB.vue"), // 淘工厂

        // }
      ]
    },
    {
      path: '/static/index',
      name: 'static',
      component: () => import("./views/static/index.vue"),
      meta: {
        title: '世网通操作手册'
      }
    },
    //问题中心
    {
      path: '/question',
      name: 'question',
      component: () => import("./views/questionIndex.vue"),
      meta: {
        title: '问题中心',
      }
    },

    //绑定帐号
    {
      path: '/bindAccount',
      name: 'bindAccount',
      component: () => import("./views/bindAccount.vue"),
      meta: {
        title: '登录',
        login: false
      }
    },
    {
      path: '/realNameCourse',
      name: 'realNameCourse',
      component: () => import("./views/realNameCourse.vue"),
      meta: {
        title: '实名教程',
      }
    },
    {
      path: '/to_realName',
      name: 'to_realName',
      component: () => import("./views/to_realName.vue"),
      meta: {
        title: '实名跳转',
        login: false
      }
    },
    {
      path: '/to_realName_iframe',
      name: 'to_realName_iframe',
      component: () => import("./views/to_realName_iframe.vue"),
      meta: {
        title: '实名跳转',
        login: false
      }
    },
    {
      path: '/realName',
      component: () => import("./components/common/emptyLayout.vue"),
      children: [
        {
          path: 'index',
          name: 'realName',
          component: () => import("./views/realName/index.vue"),
          meta: {
            login: false
          }
        },
        {
          path: 'operatorName',
          name: 'operatorName',
          component: () => import("./views/realName/operatorName.vue"),
          meta: {
            login: false
          }
        }, {
          path: 'beforeSelect',
          name: 'beforeSelect',
          component: () => import("./views/realName/beforeSelect.vue"),
        },
        {
          path: 'realNameUnicom',
          name: 'realNameUnicom',
          component: () => import("./views/realName/realNameUnicom.vue"),
          meta: {
            login: false
          }
        },
      ]
    },

    //充值引导流程
    {
      path: '/process',
      component: () => import("./components/common/emptyLayout.vue"),
      children: [
        {
          path: 'index',
          name: 'processIndex',
          component: () => import("./views/process/processIndex.vue"),
        },
        {
          path: 'plan',
          name: 'processPlan',
          component: () => import("./views/process/processPlan.vue"),
        },
      ]
    },
    //中间页
    {
      path: '/mifi',
      component: () => import("./components/common/emptyLayout.vue"),
      children: [
        {
          path: 'index',
          name: 'process',
          component: () => import("./views/middlePages/process.vue"),
          meta: {
            login: false
          }
        },
        {
          path: 'authority',
          name: 'authority',
          component: () => import("./views/middlePages/authority.vue"),
          meta: {
            login: false
          }
        },
      ]
    },

    // 问题中心
    {
      path: '/question',
      component: () => import("./components/common/emptyLayout.vue"),
      children: [
        {
          path: 'guardian',
          name: 'guardian',
          component: () => import("./views/question/guardian.vue"),
        }
      ]
    },
    // 金币签到个人中心
    {
      path: '/newUserCenter',
      name: 'emptyLayout',
      component: () => import('./components/common/emptyLayout.vue'),
      children: [
        {
          path: 'customerService',
          component: () => import('./views/newUserCenter/customerService.vue'),
          meta: {
            title: '客户服务'
          }
        }, {
          path: 'checkImei',
          component: () => import("./views/newUserCenter/checkImei.vue"),
          meta: {
            title: '设备检测助手',
          }
        }, {
          path: 'checkResult',
          name: 'checkResult',
          component: () => import("./views/newUserCenter/checkResult.vue"),
          meta: {
            title: '设备检测结果',
            keepAlive: true
          }
        }, {
          path: 'complaintCenter',
          component: () => import("./views/newUserCenter/complaintCenter.vue"),
          meta: {
            title: '投诉中心',
          }
        }, {
          path: 'complaintSubmit',
          component: () => import("./views/newUserCenter/complaintSubmit.vue"),
          meta: {
            title: '提交投诉',
          }
        }, {
          path: 'complaintRecord',
          component: () => import("./views/newUserCenter/complaintRecord.vue"),
          meta: {
            title: '投诉记录',
          }
        }, {
          path: 'complaintDetail',
          component: () => import("./views/newUserCenter/complaintDetail.vue"),
          meta: {
            title: '投诉详情',
          }
        }
      ]
    },
    {
      path: '*',
      // component:()=>import("./views/walkmanWifi.vue"),
    },
  ]
})
